import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { BRAND_HEADING_STYLES } from './styles';

const BrandHeading = ({ children, className, ...props }) => {
  const classes = classNames('typography--brand-heading', className);

  return (
    <h2 className={classes} {...props}>
      {children}
      <style jsx>{BRAND_HEADING_STYLES}</style>
    </h2>
  );
};

BrandHeading.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
};

BrandHeading.defaultProps = {
  className: '',
};

export default BrandHeading;
